export const AC_POST_CREATED = 'AC_POST_CREATED';